import auth from 'react/api/actions/auth';
import user from 'react/api/actions/user';
import tabs from 'react/api/actions/tabs';
import features from 'react/api/actions/features';
import recoverPassword from 'react/api/actions/recoverPassword';
import passwordPolicies from 'react/api/actions/passwordPolicies';
import i18n from 'react/api/actions/i18n';
import modal from 'react/api/actions/modal';
import resequenceHistory from 'react/api/actions/resequenceHistory';
import * as stopDetailsPopup from 'react/api/actions/stopDetailsPopup';
import routeSummary from 'react/api/actions/routeSummary';
import licenseStatusModal from 'react/api/actions/licenseStatusModal';
import taskScheduler from 'react/api/actions/taskScheduler';
import dashboardAnalytics from 'react/api/actions/dashboardAnalytics';
import crud from 'react/api/actions/crud';
import routeSurveyModal from 'react/api/actions/routeSurveyModal.js';
import photoGallery from 'react/api/actions/photoGallery.js';
import stockSummaryModal from 'react/api/actions/stockSummaryModal.js';
import ticketHub from 'react/api/actions/ticketHub.js';
import ticketDetails from 'react/api/actions/ticketDetails.js';
import chat from 'react/api/actions/chat';
import chatTicketActions from 'react/api/actions/chatTicketActions';
import logoffAlertModal from 'react/api/actions/logoffAlertModal';
import wizard from 'react/api/actions/wizard.js';
import samlConfiguration from 'react/api/actions/samlConfiguration.js';
import integrations from 'react/api/actions/integrations';
import footer from 'react/api/actions/footer.js';
import toastAlerts from 'react/api/actions/toastAlerts';
import routeDivisionModal from 'react/api/actions/routeDivisionModal.js';
import configEventHttpHeadersModal from 'react/api/actions/configEventHttpHeadersModal.js';
import configuration from 'react/api/actions/configuration';
import wglnIntegrationLogs from 'react/api/actions/wglnIntegrationLogs';
import modals from 'react/api/actions/modals';
import eventHttpActionLogs from 'react/api/actions/eventHttpActionLogs';
import quickAssignment from 'react/api/actions/quickAssignment';
import localzIntegration from 'react/api/actions/localzIntegration';
import localzIntegrationLogs from 'react/api/actions/localzIntegrationLogs';
import monitor from 'react/api/actions/monitor';
import sku from 'react/api/actions/sku';
import alerts from 'react/api/actions/alerts';
import photoAlbum from 'react/api/actions/photoAlbum';
import bulkDownload from 'react/api/actions/bulkDownload';
import routeDetail from 'react/api/actions/routeDetails';
import telematics from 'react/api/actions/telematics';

export default {
  configuration,
  auth,
  user,
  routeDetail,
  tabs,
  features,
  recoverPassword,
  passwordPolicies,
  i18n,
  modal,
  monitor,
  resequenceHistory,
  stopDetailsPopup,
  routeSummary,
  licenseStatusModal,
  taskScheduler,
  dashboardAnalytics,
  crud,
  routeSurveyModal,
  photoGallery,
  stockSummaryModal,
  ticketHub,
  ticketDetails,
  chat,
  wizard,
  samlConfiguration,
  chatTicketActions,
  logoffAlertModal,
  integrations,
  footer,
  toastAlerts,
  routeDivisionModal,
  wglnIntegrationLogs,
  modals,
  eventHttpActionLogs,
  configEventHttpHeadersModal,
  quickAssignment,
  localzIntegration,
  localzIntegrationLogs,
  sku,
  alerts,
  photoAlbum,
  bulkDownload,
  telematics
};
